import products from '../../api/products'

export default {
    namespaced: true,
    state: () => ({
        filters: false,
        loading: false,
        store: false,
        storeName: false,
        promo: null,
        items: []
    }),
    getters: {},
    actions: {
        getProducts ({ commit }, query) {
            commit('setLoading', true)
            return products.getProducts(query).then((response) => {
                commit('setItems', response.data.phones)
                commit('setStore', response.data.store)
                commit('setPromo', response.data.promo)
                commit('setStoreName', response.data.store_name)
                commit('setLoading', false)
            })
        },
        openFilters ({ commit }) {
            commit('setFilters', true)
        },
        closeFilters ({ commit }) {
            commit('setFilters', false)
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setStore (state, value) {
            state.store = value
        },
        setPromo (state, value) {
            state.promo = value
        },
        setStoreName (state, value) {
            state.storeName = value
        },
        setItems (state, data) {
            state.items = data
        },
        setFilters (state, bool) {
            state.filters = bool
        }
    }
}
